import { DependentsCustomType } from '../enums';

export const OptionType = {
  Select: 'select',
  Radio: 'radio',
  Checkbox: 'checkbox',
  File: 'file',
  Text: 'text',
  TextArea: 'textarea',
  Date: 'date',
};

export enum OptionSemanticTypes {
  Other = 0,
  BenefitInKind = 1,
  PriceRange = 2,
  Contribution = 3,
}

export interface OptionValue {
  name: string;
  value: number;
  priceOperator?: string;
  price?: number;
  optionValueId: number;
}

export interface OptionValidations {
  number: boolean;
  decimal: boolean;
  email: boolean;
}

export interface ProductOption {
  id: number;
  type: string;
  title: string;
  semantic: OptionSemanticTypes;
  required: boolean;
  value: string;
  values: OptionValue[];
  validations: OptionValidations;
  aditionalInformation?: string;
  isProductDocumentation: boolean;
  isReadonly: boolean;
}

export interface ProductRecurrence {
  id: number;
  title: string;
}

export interface DependentsConfigModel {
  type: DependentsCustomType;
  dependents: DependentModel[];
}

export interface DependentModel {
  id: number;
  optionId: number;
  optionName: string;
  legalName: string;
  Relationship: string;
  nationalId: string;
}
